import { render, staticRenderFns } from "./comments-tab.vue?vue&type=template&id=71acd052"
import script from "./comments-tab.vue?vue&type=script&lang=ts"
export * from "./comments-tab.vue?vue&type=script&lang=ts"
import style0 from "./comments-tab.vue?vue&type=style&index=0&id=71acd052&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71acd052')) {
      api.createRecord('71acd052', component.options)
    } else {
      api.reload('71acd052', component.options)
    }
    module.hot.accept("./comments-tab.vue?vue&type=template&id=71acd052", function () {
      api.rerender('71acd052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitor-details/comments/comments-tab.vue"
export default component.exports